import {
  GET_LAWS,
  SET_LAWS,
  GET_LAWS_ERROR,
  SET_LAW_FILTERS,
  RESET_LAW_FILTERS
} from './types'
import axios from 'axios'
import Config from 'config'
import store from 'store'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import { createLatestRequest } from 'helpers/latestRequest'
import {
  replaceByTargetFromArray,
  removeByIdFromArray
} from 'helpers/dataHelpers'


const { apiUrl } = Config.network


const startLawsRequest = createLatestRequest()

export function getLaws(next, domain, room, sorting, search, countries) {
  return function action(dispatch) {
    const { cancelToken, isStale } = startLawsRequest()
    dispatch({
      type: GET_LAWS
    })
    const url = next || `${apiUrl}laws/`
    const params = {}
    if (domain) {
      params['domain'] = domain
    }
    if (room && room.length > 0) {
      params['room'] = room.join()
    }
    if (sorting) {
      params['sorting'] = sorting
    }
    if (search) {
      params['search'] = search
    }
    if (countries && countries.length > 0) {
      params['countries'] = countries.join()
    }
    axios.get(url, { params, cancelToken }).then((body) => {
      if (isStale()) {
        return
      }
      const { data } = body
      if (next) {
        const { laws } = store.getState().laws
        dispatch({
          type: SET_LAWS,
          payload: {
            laws: [...laws, ...data.results],
            lawsNext: data.next
          }
        })
      } else {
        dispatch({
          type: SET_LAWS,
          payload: {
            laws: data.results,
            lawsNext: data.next
          }
        })
      }
    }).catch(error => {
      if (axios.isCancel(error) || isStale()) {
        return
      }
      dispatch({
        type: GET_LAWS_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}


export function removeLawById(id) {
  return function action(dispatch) {
    const { lawsNext, laws } = store.getState().laws
    let currentLaws = removeByIdFromArray(laws, id)
    dispatch({
      type: SET_LAWS,
      payload: {
        laws: currentLaws,
        lawsNext: lawsNext
      }
    })
  }
}


export function updateLawByTarget(target) {
  return function action(dispatch) {
    const { lawsNext, laws } = store.getState().laws
    let currentLaws = replaceByTargetFromArray(laws, target)
    dispatch({
      type: SET_LAWS,
      payload: {
        laws: currentLaws,
        lawsNext: lawsNext
      }
    })
  }
}

export function setLawFilters(filters) {
  return {
    type: SET_LAW_FILTERS,
    payload: {
      filters
    }
  }
}

export function resetLawFilters() {
  return {
    type: RESET_LAW_FILTERS
  }
}
